import { render } from "./P037.vue?vue&type=template&id=29447d75&scoped=true"
import script from "./P037.vue?vue&type=script&lang=js"
export * from "./P037.vue?vue&type=script&lang=js"

import "./P037.vue?vue&type=style&index=0&id=29447d75&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29447d75"]])

export default __exports__